import React from 'react';
import { Grid, Modal } from '@material-ui/core';
import { useStyles, ModalCancelButton, ModalSubmitButton } from './style/style';

type Tprops = {
  name: string;
  email: string;
  sendEmail: () => void;
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export const SendEmailModal: React.FC<Tprops> = (props: Tprops) => {
  const { name, email, sendEmail, openModal, setOpenModal } = props;

  const classes = useStyles();

  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      aria-labelledby='simple-modal-name'
      aria-describedby='simple-modal-description'
      className={classes.container}
    >
      <Grid container className={classes.sendEmailPaper}>
        <Grid item xs={12} className={classes.container}>
          <div style={{ textAlign: 'center', padding: 36, width: '100%' }}>
            <p style={{ padding: '0 10px', overflowWrap: 'break-word' }}>
              {name}
            </p>
            <p style={{ padding: '0 10px', overflowWrap: 'break-word' }}>
              {email}
            </p>
            <p>にメール送信しますか</p>
          </div>
        </Grid>

        <Grid item xs={12} className={classes.modalFooter}>
          <ModalCancelButton
            variant='contained'
            onClick={() => {
              setOpenModal(false);
            }}
          >
            キャンセル
          </ModalCancelButton>
          <ModalSubmitButton
            variant='contained'
            onClick={() => {
              sendEmail();
              setOpenModal(false);
            }}
          >
            送信する
          </ModalSubmitButton>
        </Grid>
      </Grid>
    </Modal>
  );
};
